import React from "react";
import ReactDOM from "react-dom/client";
import {BrowserRouter} from "react-router-dom";
import App from "App";

// Soft UI Dashboard React Context Provider
import {RayzayUIControllerProvider} from "context";
import {NotificationProvider} from "context/NotificationProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
      <RayzayUIControllerProvider>
          <NotificationProvider>
              <App />
          </NotificationProvider>
      </RayzayUIControllerProvider>
  </BrowserRouter>
);
